import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import CallData from "../classes/CallData" ;
import LeadStatus from "../classes/LeadStatus" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import PageNavigator from "../classes/PageNavigator" ;
import LeadsListCountRequest from "../models/LeadsListCountRequest" ;
import IconButton from "./IconButton" ;
import SortedHeader from "./SortedHeader" ;
import LeadUtils from "../classes/LeadUtils" ;
import PaginationView from "./PaginationView" ;
import Query from "../classes/Query" ;
import Button from "./Button" ;
import DashboardCardWidget from "./DashboardCardWidget" ;
import ListWrapper from "../utils/ListWrapper" ;
import ScrollView2 from "./ScrollView2" ;
import LeadsListCount from "../classes/LeadsListCount" ;
import LeadsListRequest from "../models/LeadsListRequest" ;
import TwilioClient from "../classes/TwilioClient" ;
import Lead from "../models/Lead" ;
import LeadsList from "../classes/LeadsList" ;
import TextView from "./TextView" ;
import UserProfileView from "./UserProfileView" ;
import LabelDropdown from "./LabelDropdown" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;


  export  interface  TeamOverviewViewProps extends  BaseUIProps {   key?: string ;
   user: User ;
   client: TwilioClient ;
   data: CallData ;
 }
/// To store state data for TeamOverviewView 
   class  TeamOverviewViewRefs {   columnScrollController: ui.ScrollController = new ui.ScrollController() ;
  public forItemState: Map<Lead, _ForItemState> = new Map() ;
  public forForItem ( forItem : Lead ) : _ForItemState {
 let res=this.forItemState.get(forItem);

if ( res == null ) {
 res=new _ForItemState(this,forItem);

this.forItemState.set(forItem,res);
 }

return res ; 
 }
 }

   interface  Button2WithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: _ForItemState ;
   forItem: Lead ;
 }

   class  Button2State extends  ObjectObservable {  private _disable: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
 }

   class  _Button2WithState extends  ObservableComponent<Button2WithStateProps> {   button2FocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : Button2WithStateProps ) {
 super(props);

this.initState();
 }
  public get button2 (  ) : Button2State {
 return this.props.d3eState.button2 ; 
 }
  public get forItem (  ) : Lead {
 return this.props.forItem ; 
 }
  public get d3eState (  ) : _ForItemState {
 return this.props.d3eState ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('button2',null,this.button2);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('forItem',this.props.forItem);

this.on([ 'button2', 'forItem', 'forItem.status' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : Button2WithStateProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.forItem !== this.props.forItem ) {
 this.updateObservable('forItem',prevProps.forItem,this.props.forItem);

this.fire('forItem',this);
 }
 }
  public dispose (  ) : void {
 super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ width:120, child:Button({ decoration:this.forItem.status.name === 'New' ? new ui.BoxDecoration({color:cStyle.c4,borderRadius:ui.BorderRadius.circular(3.0)}) : this.forItem.status.name === 'Inprogress' ? new ui.BoxDecoration({color:cStyle.c5,borderRadius:ui.BorderRadius.circular(3.0)}) : this.forItem.status.name === 'Closed' ? new ui.BoxDecoration({color:cStyle.c7,borderRadius:ui.BorderRadius.circular(3.0)}) : this.forItem.status.name === 'Contacted' ? new ui.BoxDecoration({color:cStyle.c6,borderRadius:ui.BorderRadius.circular(3.0)}) : new ui.BoxDecoration({borderRadius:ui.BorderRadius.circular(3.0)}), padding:this.forItem.status.name === 'New' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : this.forItem.status.name === 'Inprogress' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : this.forItem.status.name === 'Closed' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : this.forItem.status.name === 'Contacted' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}), disable:this.button2.disable, onFocusChange:( val ) => {
  }
, child:TextView({ data:this.forItem.status.name, style:new ui.TextStyle({color:cStyle.c14}), className:'x8c6' }) }), className:'x2133 hc' }) ; 
 }
 }
function Button2WithState ( props : Button2WithStateProps ) {
 return React.createElement(_Button2WithState,props) ; 
 }


   class  _ForItemState {   parent: TeamOverviewViewRefs ;
   forItem: Lead ;
   button2: Button2State = new Button2State() ;
 public constructor ( parent,forItem ) {
 this.parent=parent;

this.forItem=forItem;
 }
 }

   class  _TeamOverviewViewState extends  ObservableComponent<TeamOverviewViewProps> {   static defaultProps = { user:null, client:null, data:null } ;
   d3eState: TeamOverviewViewRefs = new TeamOverviewViewRefs() ;
   request: LeadsListRequest = null ;
   leadsList: LeadsList = null ;
   countRequest: LeadsListCountRequest = null ;
   leadsListCountQuery: LeadsListCount = null ;
   allLeads: Array<Lead> = ListWrapper.widget(this,'allLeads') ;
   leads: Array<Lead> = ListWrapper.widget(this,'leads') ;
   searchText: string = '' ;
   leadFilteredList: Array<Lead> = ListWrapper.widget(this,'leadFilteredList') ;
   filterByRange: string = 'Today' ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : TeamOverviewViewProps ) {
 super(props);

this.initState();
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public get client (  ) : TwilioClient {
 return this.props.client ; 
 }
  public get data (  ) : CallData {
 return this.props.data ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('user',this.props.user);

this.on([ 'request', 'request.applyStatus', 'request.ascending', 'request.fromDate', 'request.offset', 'request.orderBy', 'request.pageSize', 'request.status', 'request.toDate', 'request.user' ],this.computeLeadsList);

this.computeLeadsList();

this.on([ 'countRequest', 'countRequest.fromDate', 'countRequest.toDate', 'countRequest.user' ],this.computeLeadsListCountQuery);

this.computeLeadsListCountQuery();

this.on([ 'leadsListCountQuery', 'leadsListCountQuery.items' ],this.computeAllLeads);

this.computeAllLeads();

this.on([ 'leadsList', 'leadsList.items' ],this.computeLeads);

this.computeLeads();

this.on([ 'leads', 'leads.name', 'searchText' ],this.computeLeadFilteredList);

this.computeLeadFilteredList();

this.updateSyncProperty('data',this.props.data);

this.on([ 'allLeads', 'allLeads.status', 'filterByRange', 'leadFilteredList', 'leadFilteredList.company', 'leadFilteredList.createdDate', 'leadFilteredList.name', 'leadFilteredList.phone', 'leadFilteredList.updatedDate', 'leadsList', 'leadsList.count', 'request', 'request.ascending', 'request.offset', 'request.orderBy', 'request.pageSize', 'user' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : TeamOverviewViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.fire('user',this);
 }

if ( prevProps.client !== this.props.client ) {
 this.fire('client',this);
 }

if ( prevProps.data !== this.props.data ) {
 this.updateObservable('data',prevProps.data,this.props.data);

this.fire('data',this);
 }
 }
  public setRequest ( val : LeadsListRequest ) : void {
 let isValChanged :boolean=this.request !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('request',this.request,val);

this.request=val;

this.fire('request',this);
 }
  public setLeadsList ( val : LeadsList ) : void {
 let isValChanged :boolean=this.leadsList !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('leadsList',this.leadsList,val);

this.leadsList=val;

this.fire('leadsList',this);
 }
  public computeLeadsList  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setLeadsList(( await Query.get().getLeadsList(UsageConstants.QUERY_GETLEADSLIST_TEAMOVERVIEWVIEW_PROPERTIES_LEADSLIST_COMPUTATION,this.request)));
 }
 catch ( exception ) {
 console.log(' exception in computeLeadsList : ' + exception.toString());

this.setLeadsList(null);
 }
 }
  public setCountRequest ( val : LeadsListCountRequest ) : void {
 let isValChanged :boolean=this.countRequest !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('countRequest',this.countRequest,val);

this.countRequest=val;

this.fire('countRequest',this);
 }
  public setLeadsListCountQuery ( val : LeadsListCount ) : void {
 let isValChanged :boolean=this.leadsListCountQuery !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('leadsListCountQuery',this.leadsListCountQuery,val);

this.leadsListCountQuery=val;

this.fire('leadsListCountQuery',this);
 }
  public computeLeadsListCountQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setLeadsListCountQuery(( await Query.get().getLeadsListCount(UsageConstants.QUERY_GETLEADSLISTCOUNT_TEAMOVERVIEWVIEW_PROPERTIES_LEADSLISTCOUNTQUERY_COMPUTATION,this.countRequest)));
 }
 catch ( exception ) {
 console.log(' exception in computeLeadsListCountQuery : ' + exception.toString());

this.setLeadsListCountQuery(null);
 }
 }
  public setAllLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.allLeads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('allLeads',this.allLeads,val);

this.allLeads.clear();

this.allLeads.addAll(val);

this.fire('allLeads',this);
 }
  public addToAllLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.allLeads.contains(val) ) this.allLeads.add(val);
 }
 else {
 this.allLeads.remove(this.allLeads.elementAt(index));

this.allLeads.add(val);
 }

this.fire('allLeads',this,val,true);

this.updateObservable('allLeads',null,val);
 }
  public removeFromAllLeads ( val : Lead ) : void {
 this.allLeads.remove(val);

this.fire('allLeads',this,val,false);

this.removeObservable('allLeads',val);
 }
  public computeAllLeads  =  (  ) : void  =>  {
 try {
 this.setAllLeads(Array.from(this.leadsListCountQuery.items.isNotEmpty ? this.leadsListCountQuery.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeAllLeads : ' + exception.toString());

this.setAllLeads([  ]);
 }
 }
  public setLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.leads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('leads',this.leads,val);

this.leads.clear();

this.leads.addAll(val);

this.fire('leads',this);
 }
  public addToLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.leads.contains(val) ) this.leads.add(val);
 }
 else {
 this.leads.remove(this.leads.elementAt(index));

this.leads.add(val);
 }

this.fire('leads',this,val,true);

this.updateObservable('leads',null,val);
 }
  public removeFromLeads ( val : Lead ) : void {
 this.leads.remove(val);

this.fire('leads',this,val,false);

this.removeObservable('leads',val);
 }
  public computeLeads  =  (  ) : void  =>  {
 try {
 this.setLeads(Array.from(this.leadsList.items.isNotEmpty ? this.leadsList.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeLeads : ' + exception.toString());

this.setLeads([  ]);
 }
 }
  public setSearchText ( val : string ) : void {
 let isValChanged :boolean=this.searchText !== val;

if ( !isValChanged ) {
 return ; 
 }

this.searchText=val;

this.fire('searchText',this);
 }
  public setLeadFilteredList ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.leadFilteredList,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('leadFilteredList',this.leadFilteredList,val);

this.leadFilteredList.clear();

this.leadFilteredList.addAll(val);

this.fire('leadFilteredList',this);
 }
  public addToLeadFilteredList ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.leadFilteredList.contains(val) ) this.leadFilteredList.add(val);
 }
 else {
 this.leadFilteredList.remove(this.leadFilteredList.elementAt(index));

this.leadFilteredList.add(val);
 }

this.fire('leadFilteredList',this,val,true);

this.updateObservable('leadFilteredList',null,val);
 }
  public removeFromLeadFilteredList ( val : Lead ) : void {
 this.leadFilteredList.remove(val);

this.fire('leadFilteredList',this,val,false);

this.removeObservable('leadFilteredList',val);
 }
  public computeLeadFilteredList  =  (  ) : void  =>  {
 try {
 this.setLeadFilteredList(Array.from(this.leads.where(( c ) => c.name.toLowerCase().contains(this.searchText.toLowerCase())).toList()));
 }
 catch ( exception ) {
 console.log(' exception in computeLeadFilteredList : ' + exception.toString());

this.setLeadFilteredList([  ]);
 }
 }
  public setFilterByRange ( val : string ) : void {
 let isValChanged :boolean=this.filterByRange !== val;

if ( !isValChanged ) {
 return ; 
 }

this.filterByRange=val;

this.fire('filterByRange',this);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ScrollView2({child:ui.Column({ children:[ UserProfileView({ user:this.user, className:'x2ef hc h', key:'0' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'Team Overview', style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour x749', key:'0' }), ui.Row({ children:[ LabelDropdown<string>({ value:this.filterByRange, items:LeadUtils.filterRanges, onChanged:( value ) => {
 this.onDateFilterDropdownOnChangedHandler(value,this.d3eState);
 }
, builder:( context,item ) => {
 return TextView({ data:item }) ; 
 }
, key:'0' }) ], key:'1' }) ], className:'x2a1 hc h', key:'1' }), ui.Row({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ children:[ ([ LeadStatus.New, LeadStatus.AttemptedContact, LeadStatus.Contacted, LeadStatus.FollowUp, LeadStatus.DemoRequested ]).expand(( topStatus ) => [ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:DashboardCardWidget({ title:topStatus, bgcolor:topStatus === LeadStatus.New ? cStyle.c4 : topStatus === LeadStatus.AttemptedContact ? cStyle.c9 : topStatus === LeadStatus.Contacted ? cStyle.c6 : topStatus === LeadStatus.FollowUp ? cStyle.c5 : topStatus === LeadStatus.DemoRequested ? cStyle.c9 : cStyle.c4, statusCount:this.allLeads.where(( c ) => c.status.name === topStatus.name).length, onClick:( leadStatus ) => {
 this.onTopCardClickHandler(leadStatus,topStatus,this.d3eState);
 }
 }), key:topStatus?.toString(), className:'x716 hc h' }) ]) ], className:'x5ac8 hc h', key:'0' }), ui.Row({ children:[ ([ LeadStatus.Suspect, LeadStatus.Prospect, LeadStatus.ClosedWon, LeadStatus.Closed ]).expand(( bottomStatus ) => [ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:DashboardCardWidget({ title:bottomStatus, bgcolor:bottomStatus === LeadStatus.Suspect ? cStyle.c6 : bottomStatus === LeadStatus.Prospect ? cStyle.c5 : bottomStatus === LeadStatus.ClosedWon ? cStyle.c7 : bottomStatus === LeadStatus.Closed ? cStyle.c7 : cStyle.c5, statusCount:this.allLeads.where(( c ) => c.status.name === bottomStatus.name).length, onClick:( leadStatus ) => {
 this.onBottomCardClickHandler(leadStatus,bottomStatus,this.d3eState);
 }
 }), key:bottomStatus?.toString(), className:'x4b8 hc h' }) ]) ], className:'x1e0 hc h', key:'1' }) ], className:'x79a hc h', key:'0' }) ], className:'xb029 hc h', key:'2' }), ui.Column({ children:[ ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), columnWidths:{0:new ui.FlexColumnWidth(1),1:new ui.FlexColumnWidth(1),2:new ui.FlexColumnWidth(1),3:new ui.FlexColumnWidth(1),4:new ui.FlexColumnWidth(1),5:new ui.FixedColumnWidth(70),}, children:[ ui.TableRow({ children:[ ui.TableCell({ child:TextView({ data:'Assigned Date', className:'hc' }), className:'TableCellHeader table-column x9d9e hc', key:'0' }), ui.TableCell({ child:SortedHeader({ name:'Lead Name', assending:this.request.ascending, sorted:this.request.orderBy === 'name', onChanged:( value ) => {
 this.onNameSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x172 hc h' }), className:'TableCellHeader table-column xaf26 hc h', key:'1' }), ui.TableCell({ child:SortedHeader({ name:'Phone', assending:this.request.ascending, sorted:this.request.orderBy === 'phone', onChanged:( value ) => {
 this.onPhoneSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'xa58 hc h' }), className:'TableCellHeader table-column xfac hc h', key:'2' }), ui.TableCell({ child:TextView({ data:'Company', className:'hc' }), className:'TableCellHeader table-column x894 hc', key:'3' }), ui.TableCell({ child:SortedHeader({ name:'Status', assending:this.request.ascending, sorted:this.request.orderBy === 'status', onChanged:( value ) => {
 this.onStatusSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x71f hc h' }), className:'TableCellHeader table-column xbcf hc h', key:'4' }), ui.TableCell({ child:TextView({ data:'', className:'hc' }), className:'TableCellHeader table-column x15aa hc', key:'5' }) ], className:'TableHeader table-row xb08 hc h', key:'0' }), (this.leadFilteredList).expand(( forItem ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.updatedDate !== null ? LeadUtils.toGMTFromDateTime(forItem.createdDate,{ format:'dd EEE, MMM y HH:mm' }) : LeadUtils.toGMTFromDateTime(forItem.updatedDate,{ format:'dd EEE, MMM y HH:mm' }), className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.name, className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.phone, className:'hc' }), className:'table-column hc', key:'2' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.company, className:'hc' }), className:'table-column hc', key:'3' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.start, children:[ Button2WithState({ d3eState:this.d3eState.forForItem(forItem), forItem:forItem, key:'0' }), ui.Container({ key:'1' }) ], className:'xcfd hc h' }), className:'table-column xa42 hc h', key:'4' }), ui.TableCell({ child:IconButton({ icon:MaterialIcons.edit, tooltip:'Edit', onPressed:(  ) => {
 this.onLeadEditHandler(this.d3eState.forForItem(forItem));
 }
, className:'hc' }), className:'table-column hc', key:'5' }) ], onTap:( e ) => {
 e.stopPropagation();

this.onTableRowGestureHandler(this.d3eState.forForItem(forItem));
 }
, className:'TableRow1 table-row xbad6 hc h', key:forItem?.ident }) ]) ], className:'Table1 xe060 hc h', key:'0' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.end, children:[ PaginationView({ pageSize:this.request.pageSize, total:this.leadsList?.count ?? 0, offset:this.request.offset, onChange:( pageSize,offset ) => {
 this.onChangePaginationViewHandler(pageSize,offset,this.d3eState);
 }
, key:'0' }) ], className:'xbe4 hc h', key:'1' }) ], className:'BaseViewStyle xe923 hc h', key:'3' }) ], className:ui.join('TeamOverviewView x5a2 hc vc h v ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }),scrollDirection:ui.Axis.vertical,className:'TeamOverviewView x5a2 hc vc h v',controller:this.d3eState.columnScrollController}) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setFilterByRange('Current Week');

this.setRequest(new LeadsListRequest({ user:this.user, pageSize:50, offset:0, orderBy:'', ascending:false, fromDate:LeadUtils.getFromDateFilter(this.filterByRange), toDate:LeadUtils.getToDateFilter(this.filterByRange) }));

this.setCountRequest(new LeadsListCountRequest({ user:this.user, fromDate:LeadUtils.getFromDateFilter(this.filterByRange), toDate:LeadUtils.getToDateFilter(this.filterByRange) }));
 }
  public onChangePaginationViewHandler  =  ( pageSize : number,offset : number,d3eState : TeamOverviewViewRefs ) : void  =>  {
 this.request.setPageSize(pageSize);

this.request.setOffset(offset);

this.setRequest(this.request.deepClone());
 }
  public onNameSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : TeamOverviewViewRefs ) : void  =>  {
 this.request.setOrderBy('name');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onPhoneSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : TeamOverviewViewRefs ) : void  =>  {
 this.request.setOrderBy('phone');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onStatusSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : TeamOverviewViewRefs ) : void  =>  {
 this.request.setOrderBy('status');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onTableRowGestureHandler  =  ( d3eState : _ForItemState ) : void  =>  {
 this.navigator.pushLeadOverviewPage({ lead:d3eState.forItem, user:this.user, client:this.client, data:this.data, replace:false, target:'main' });
 }
  public onDateFilterDropdownOnChangedHandler  =  ( value : string,d3eState : TeamOverviewViewRefs ) : void  =>  {
 this.setFilterByRange(value);

this.request.setFromDate(LeadUtils.getFromDateFilter(this.filterByRange));

this.request.setToDate(LeadUtils.getToDateFilter(this.filterByRange));

this.setRequest(this.request.deepClone());

this.countRequest.setFromDate(LeadUtils.getFromDateFilter(this.filterByRange));

this.countRequest.setToDate(LeadUtils.getToDateFilter(this.filterByRange));

this.setCountRequest(this.countRequest.deepClone());
 }
  public onLeadEditHandler  =  ( d3eState : _ForItemState ) : void  =>  {
 this.navigator.pushLeadInformationPage({ user:this.user, lead:d3eState.forItem, replace:false, client:this.client, target:'main', data:this.data, isNewObj:false });
 }
  public onTopCardClickHandler  =  ( leadStatus : LeadStatus,topStatus : LeadStatus,d3eState : TeamOverviewViewRefs ) : void  =>  {
 this.request.setApplyStatus(true);

this.request.setStatus(leadStatus);

this.setRequest(this.request.deepClone());
 }
  public onBottomCardClickHandler  =  ( leadStatus : LeadStatus,bottomStatus : LeadStatus,d3eState : TeamOverviewViewRefs ) : void  =>  {
 this.request.setApplyStatus(true);

this.request.setStatus(leadStatus);

this.setRequest(this.request.deepClone());
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
 }
export default function TeamOverviewView ( props : TeamOverviewViewProps ) {
 return React.createElement(_TeamOverviewViewState,{ ..._TeamOverviewViewState.defaultProps, ...props }) ; 
 }
